import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseResponse } from 'src/app/core/models/responses/base-response';
import { BaseService } from 'src/app/core/services/base.service';
import { SalesFilter } from 'src/app/models/filters/sales-filter';
import { Sales } from 'src/app/models/sales/sales';
import { SalesWithExchangeRequest, SalesWithExchangeResponse } from 'src/app/models/sales/sales-with-exchange-request';
import { StaffSalesDetailItem, StaffSalesReportRequest, StaffSalesReportResponse } from 'src/app/models/sales/staff-sales-report';
import { environment } from 'src/environments/environment';
import { BasePagingRequest } from '../core/models/requests/base-paging-request';

@Injectable({
  providedIn: 'root'
})
export class SalesService extends BaseService<Sales, SalesFilter, number> {

  apiUrl = environment.urlAddress + '/Sales';
  constructor(private http: HttpClient) {
    super(http, environment.urlAddress + '/Sales')
   }

  createWithExchange(request: SalesWithExchangeRequest): Observable<BaseResponse<SalesWithExchangeResponse>> {
    return this._http.post<BaseResponse<SalesWithExchangeResponse>>(this._base + '/create-with-exchange', request);
  }

  getStaffReport(request: StaffSalesReportRequest): Observable<BaseResponse<StaffSalesReportResponse>> {
    return this._http.post<BaseResponse<StaffSalesReportResponse>>(this._base + '/staff-report', request);
  }

  getStaffReportDetail(request: StaffSalesReportRequest): Observable<BaseResponse<StaffSalesDetailItem[]>> {
    return this._http.post<BaseResponse<StaffSalesDetailItem[]>>(this._base + '/staff-report/detail', request);
  }
  }